import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import API from "@beardeddevops/react.api";
import {Alert} from "reactstrap";

/**
 *  @property {Regions_Object} state
 *  @property {object} model
 *  @property {Regions_Properties} model.properties
 *  @property {Regions_Is} model.is
 *  @property {Regions_Has} model.has
 */
export default class Region extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Regions._name);
		this.noDelete = true;
		this.redirect = this.props.baseUrl;
	}

	componentDidMount() {
		super.componentDidMount();
		if( !this.props.id ) {
			this.setState({
				latitude: API.LocationLatitude,
				longitude: API.LocationLongitude,
			})
		}
	}

	/**
	 * @param prevProps
	 * @param {Regions_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
		if( this.props.id !== prevProps.id && !this.props.id ) {
			this.setState({
				latitude: API.LocationLatitude,
				longitude: API.LocationLongitude,
			})
		}
	}

	loadSelfBefore = async (data) => {
		let {onData} = this.props;

		if (typeof onData === 'function') onData(data);

		return data;
	}

	form = () => {
		let {properties} = this.model;
		let object = this.state
		let {loading} = this.state

		return (
			<div>
				<Alert color="warning">
					<p style={{fontSize: '18px', marginBottom: '0px'}}>
						Updating the ranking for regions will place it in that position and shift other rankings up and down.
					</p>
				</Alert>
				<fieldset>
					<div className="row">
						<div className="col-md">
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.abbreviation}
									value={object.abbreviation}
									error={object.abbreviation_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="row">
								<div className="col-2">
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.latitude}
											value={object.latitude}
											error={object.latitude_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.longitude}
											value={object.longitude}
											error={object.longitude_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.radius}
											value={object.radius}
											error={object.radius_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.ranking}
											value={object.ranking}
											error={object.ranking_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.metro_walk_ranking}
											value={object.metro_walk_ranking}
											error={object.metro_walk_ranking_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
